module.exports = __webpack_public_path__ + "img/file-approval-survey.f69d8d53.png";